
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteVacancyForm from "@/form/Settings/site/vacancy";
import {SalonsStore} from "@/store/modules/Salons";
import {CurrencyStore} from "@/store/modules/Currency";
import {ISalons, ISalonsListItem} from "@/entity/salons/salons.types";
import {ICurrency} from "@/entity/currency/currency.types";
import { mixins } from 'vue-class-component';
import { SalonsMix } from '@/UI/mixins/SalonsMix';


@Component({
    components: {FormGroup},
})
export default class VacancyCreateForm extends mixins (SalonsMix){
    @Prop() form!:  SiteVacancyForm;

    dataSalonsStore: Array <ISalonsListItem> = []
    scrollPage = 1;
    totalRecords = 0;
    sourceLength = 0;

    mounted() {
        this.dynamicCabinLoading()
    }

    async dynamicCabinLoading(): Promise<void> {
        await SalonsStore.fetchAll({limit: this.AppPageParams.pageSize})
        console.log(SalonsStore.salons?.data,'ORA')
        let items = []
        items = SalonsStore.salons!.data
        items.forEach((item) => {
            this.dataSalonsStore.push(item)
        })
    }
    async handleScroll(event: any): Promise<void> {
        let target = event.target;
        if (Number(target.scrollTop) + Number(target.offsetHeight) >= target.scrollHeight) {
            console.log("***");
            if (this.dataSalonsStore.length > this.totalRecords) {
                this.scrollPage = this.scrollPage + 1;
                try {
                    await SalonsStore.fetchAll({ skip: this.calcSkipPage(this.scrollPage) , limit: this.AppPageParams.pageSize });
                    this.constructDataSearch();
                } catch (e) {
                    console.log("ERROR", e);
                }
            }
        }
    }
    constructDataSearch(): void {
        if (SalonsStore.salons) {
            const items = SalonsStore.salons.data
            if (items) {
                items.forEach((item) => {
                    this.dataSalonsStore.push(item);
                });
            }
        }
    }

    async created(): Promise<void> {
        console.log('creted');
    }
    // get salons(): ISalons | null {
    //   return SalonsStore.salons;
    // }
    get currency(): ICurrency[] {
        return CurrencyStore.currency;
    }
}
